<template>
  <v-card>
    <v-card-title>
      <span class="headline mt-2"
        ><h1>Условия предоставления доступа к сервису <br> VMMM.ru</h1></span>
      <hr>
    </v-card-title>
    <v-card-text>
      <div clss="clear"></div>
      <p>
        Вы получаете право бесплатно использовать калькулятор, в том числе в целях извлечения прибыли, в течение 1 месяца, при этом берете обязательство предоставить отзыв от каждого пользователя о ценности, достоинствах, недостатках и своих пожеланиях о дальнейшем развитии этого проекта.
      </p>
      <p>
        Регистрируясь в сервисе, вы соглашаетесь на предоставление <a href='https://docs.google.com/forms/d/11PmpqVGn7QiVmByLpc6rqFeXaiKAjk-jcSi09NBY-_Y/edit' target="_blank">отзыва</a>
        <br>
        Свои вопросы и комментарии в дальнейшем можете направлять на почту <a href="mailto:help@vmmm.ru"> help@vmmm.ru</a>
      </p>
      <p>
        Также вы можете присоединиться к нашему каналу в телеграмм <a href="https://t.me/vmmm_ru">https://t.me/vmmm_ru</a>, чтобы узнавать о новостях сервиса и следить за обновлениями
      </p>

      <div id="thumbnails">
        <ul></ul>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="$emit('close', false)"
        >Закрыть</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: 'register_police'
};
</script>

<style></style>
